import { TableHead, TableRow, TableCell } from '@mui/material'
import { ReactElement } from 'react'
import { Translate } from 'src/i18n'
import { defaultTheme } from 'src/theme'
import styled from 'styled-components'

interface Header {
  name: string
  mandatory?: boolean
}

const headerInfo: Header[] = [
  { name: 'lineCode' },
  { name: 'partNum', mandatory: true },
  { name: 'qty' },
  { name: 'comments' },
  { name: '' },
]

const Header = (): ReactElement => {
  const mandatory = <AdditionalText>({Translate('required')})</AdditionalText>

  return (
    <TableHead>
      <HeaderRow>
        {headerInfo.map((column) => (
          <HeaderCell key={column.name}>
            {column.name && <ColumnName>{Translate(column.name)}</ColumnName>}
            {column.mandatory && mandatory}
          </HeaderCell>
        ))}
      </HeaderRow>
    </TableHead>
  )
}

const HeaderRow = styled(TableRow)`
  background: ${defaultTheme.colors.rowFeaturedBackground};
  box-shadow:
    inset 0px -1px 0px ${defaultTheme.colors.borderTable},
    inset 0px 1px 0px ${defaultTheme.colors.borderTable};
  height: 40px;
  margin-top: 16px;
`

const HeaderCell = styled(TableCell)`
  padding: 0px 16px;
  border-bottom: none;
`

const ColumnName = styled.span`
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  text-wrap: nowrap;
  color: ${defaultTheme.colors.columnBorder};
`

const AdditionalText = styled(ColumnName)`
  margin-left: 0.4rem;
  font-weight: 400;
  font-size: 11px;
  text-transform: none;
`

export default Header
